export default class FCvpt {
  constructor(
    id,
    kode1,
    description,
    fdivisionBean,
    statusActive= true,

    address,
    city,
    phone,
    email,
    contact,
    nktt,
    aktaNumber,
    aktaDate,
    namaPemilik,
    
    created,
    modified,
    modifiedBy
  ) {
    this.id = id;
    this.kode1 = kode1;
    this.description = description;
    this.statusActive = statusActive;
    this.fdivisionBean = fdivisionBean;

    this.address = address;
    this.city = city;
    this.phone = phone;
    this.email = email;
    this.contact = contact;
    this.nktt = nktt;
    this.aktaNumber = aktaNumber;
    this.aktaDate = aktaDate;
    this.namaPemilik = namaPemilik;
   

    this.created = created;
    this.modified = modified;
    this.modifiedBy = modifiedBy;
  }

}
